import ConstructionWidget from './construction-widget';
import {
  setActivePlanning,
  setActiveConstructionId as setActiveConstructionIdAction,
  setMobileMapType,
} from 'store/state/insightsContext/actions';
import { State } from 'store/state';
import { connect } from 'react-redux';
import { insightsLoadingSelector } from 'store/state/domainData/selectors';
import { InsightSection } from 'store/state/insightsContext';
import {
  constructionsInFilingApproved,
  constructionsInFiling,
  constructionsInConstruction,
  constructionCarouselDataSelector,
} from 'store/state/selectors/insights/construction';
import {
  isCollapsedInsightsSelector,
  showInsightsCarouselSelector,
} from 'store/state/selectors/insights/insightSections';
import { setNewUnitPageMapExpanded } from 'store/state/app/actions';


const mapStateToProps = (state: State) => ({
  inFiling: constructionsInFiling(state),
  inFilingApproved: constructionsInFilingApproved(state),
  inConstruction: constructionsInConstruction(state),
  loading: insightsLoadingSelector(state),
  carouselData: constructionCarouselDataSelector(state),
  isCollapsed: isCollapsedInsightsSelector(state),
  showCarousel: showInsightsCarouselSelector(state),
});

const mapDispatchToProps = {
  setActiveInsightId: setActivePlanning,
  setActiveConstructionId: setActiveConstructionIdAction,
  onSeeOnMapClick: () => setMobileMapType(InsightSection.Planning),
  expandNewUnitPageMap: setNewUnitPageMapExpanded,
};

export default connect(mapStateToProps, mapDispatchToProps)(ConstructionWidget);
